import * as React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { BsArrowUpRight } from 'react-icons/bs';

// const ADMIN_API = "http://localhost:5000/api/public/enquiry"; // local
const ADMIN_API = "https://admin.sssachievers.com/api/public/enquiry"; // production

const EnquiryForm = () => {
  const [formData, setFormData] = React.useState({
    name: "",
    phone: "",
    className: "",
    enquiry: ""
  });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      setPhoneError("");
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validatePhone = (phone) => {
    return /^[6-9][0-9]{9}$/.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validatePhone(formData.phone)) {
      setPhoneError("Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(ADMIN_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          studentName: formData.name,
          phone: formData.phone,
          studentClass: formData.className,
          notes: formData.enquiry,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Submission failed. Please try again.");
        return;
      }

      window.location.href = "/thank-you";
    } catch {
      setError("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className='enquiry-form'
      variant="outlined"
      sx={{ maxWidth: 360, borderRadius: '16px', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)' }}
    >
      {/* Header */}
      <Box sx={{ p: 2 }} className='flex items-center justify-center'>
        <img
          src="./images/chat.png"
          alt="Chat"
          height={30}
          width={30}
          className='mr-3'
        />
        <Typography
          variant="subtitle1"
          component="div"
          sx={{ fontWeight: 'bold', color: '#0097b2' }}
        >
          Enquire for Foundation Batch
        </Typography>
      </Box>

      <Divider />

      {/* Form */}
      <Box sx={{ p: 2 }}>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter your full name"
              className="w-full p-2 border rounded focus:outline-none hover:border-[#0097b2] focus:border-[#0097b2]"
              name='name'
              required
              onChange={handleChange}
              value={formData.name}
            />
          </div>

          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              placeholder="10-digit mobile number"
              className={`w-full p-2 border rounded focus:outline-none hover:border-[#0097b2] focus:border-[#0097b2] ${phoneError ? 'border-red-500' : ''}`}
              name='phone'
              required
              maxLength={10}
              onChange={handleChange}
              value={formData.phone}
            />
            {phoneError && <p className="text-red-500 text-xs mt-1">{phoneError}</p>}
          </div>

          <select
            name="className"
            className="w-full p-2 mb-3 border rounded focus:outline-none hover:border-[#0097b2] focus:border-[#0097b2]"
            required
            onChange={handleChange}
            value={formData.className}
          >
            <option value="">Select Your Class</option>
            <option value="Class 8">Class 8 Foundation</option>
            <option value="Class 9">Class 9 Foundation</option>
            <option value="Class 10">Class 10 Board</option>
            <option value="Class 11">Class 11 Foundation</option>
            <option value="Class 12">Class 12 Board</option>
            <option value="Other">Other</option>
          </select>

          <textarea
            placeholder="Type your enquiry here..."
            className="w-full p-2 mb-3 border rounded focus:outline-none hover:border-[#0097b2] focus:border-[#0097b2]"
            name='enquiry'
            onChange={handleChange}
            value={formData.enquiry}
          ></textarea>

          {error && (
            <p className="text-red-500 text-sm mb-3">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="flex justify-center items-center bg-[#0097b2] text-white w-full p-2 rounded hover:bg-[#007f96] transition-colors duration-200 font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? "Submitting..." : (
              <>Submit Enquiry <BsArrowUpRight className='ml-2 text-[1.2rem]' /></>
            )}
          </button>
        </form>
      </Box>
    </Card>
  );
};

export default EnquiryForm;
